import React from 'react'
import { LinearProgress } from '@mui/material'
import { alpha } from '@mui/material/styles'
import AccessAlarm from '@mui/icons-material/AccessAlarm'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'

import { theme } from '../../themes/theme.js'
import { BoldMedBodyText } from '../styles/Text.js'
import { DUE_DATE_BUSINESS_DAYS } from '../../util/consts.js'

const ProgressRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

const Icon = styled(AccessAlarm, {
  shouldForwardProp: prop => prop !== 'color'
})`
  color: ${props => `${props.color}`};
  width: 18px;
`

const ProgressBar = styled(LinearProgress, { shouldForwardProp: prop => prop !== 'color' })`
  flex-grow: 1;
  height: 5px;
  border-radius: ${theme.borderRadius.iconButton};
  background-color: ${props => `${alpha(props.color, 0.3)}`};

  .MuiLinearProgress-bar {
    border-radius: 5px;
    background-color: ${props => `${props.color}`};
  }
`

const CountdownBar = ({ daysTaken, totalDays = DUE_DATE_BUSINESS_DAYS, isCompleted = false, progressColor = 'rgba(16, 192, 208, 1)' }) => {
  const remaining = totalDays - daysTaken
  const displayValue = isCompleted ? daysTaken : remaining
  const unit = Math.abs(displayValue) === 1 ? 'Day' : 'Days'
  const clampedDaysTaken = Math.min(totalDays, Math.max(0, daysTaken))
  const progressPercent = totalDays > 0 ? Math.min(100, Math.max(0, (clampedDaysTaken / totalDays) * 100)) : 0

  return (
    <ProgressRow>
      <Icon color={progressColor} />
      <ProgressBar color={progressColor} variant="determinate" value={progressPercent} />
      <BoldMedBodyText>{isCompleted ? `Completed in ${displayValue} ${unit}` : `${displayValue} ${unit}`}</BoldMedBodyText>
    </ProgressRow>
  )
}

CountdownBar.propTypes = {
  daysTaken: PropTypes.number.isRequired,
  totalDays: PropTypes.number,
  isCompleted: PropTypes.bool,
  progressColor: PropTypes.string
}

export default CountdownBar
